import moment from 'moment';

import { getIsSupressedByRules, getIsAutoShow } from 'app/modules/ui';
import { AUTHENTICATION_SUCCESS, AUTHENTICATION_ERROR } from 'app/modules/app/constants';
import {
  SET_INTERACTIVE_ONBOARDING,
  WIDGET_AUTO_SHOW,
  WIDGET_HIDE,
  WIDGET_INITIATE,
  WIDGET_MINIMIZE,
  WIDGET_SUPPRESS,
  WIDGET_UNSUPPRESS,
  WIDGET_UNMINIMIZE,
  WIDGET_UPDATE_COMPOSITION_DRAFT,
  WIDGET_UPDATE_STAGE,
  WIDGET_UPDATE_VISIBILITY,
} from 'app/modules/ui/constants';
import { CONFIG_CHAT_THROTTLED, CONFIG_OFFICE_CLOSED } from 'app/modules/configuration/constants';
import { STAGES } from 'app/modules/ui';

/*
 * Reducers
 */

export default function reducer(state = {}, action) {
  switch (action.type) {
    case WIDGET_AUTO_SHOW:
      return {
        ...state,
        autoShowWidget: true,
      };
    case WIDGET_HIDE:
      return {
        ...state,
        isVisible: false,
      };
    case WIDGET_MINIMIZE:
      return {
        ...state,
        minimizedAt: moment()
          .utc()
          .format(),
        isMinimized: true,
      };
    case WIDGET_UNMINIMIZE:
      return {
        ...state,
        minimizedAt: null,
        isMinimized: false,
      };
    case AUTHENTICATION_ERROR:
      return {
        ...state,
        stage: STAGES.ONBOARDING,
      };
    case AUTHENTICATION_SUCCESS:
      return {
        ...state,
        stage: STAGES.CHAT,
      };
    case CONFIG_OFFICE_CLOSED:
      return {
        ...state,
        stage: STAGES.CHAT_CLOSED,
      };
    case CONFIG_CHAT_THROTTLED:
      return {
        ...state,
        stage: STAGES.CHAT_THROTTLED,
      };
    case WIDGET_UPDATE_COMPOSITION_DRAFT:
      return {
        ...state,
        compositionDraft: action.record.text,
      };
    case WIDGET_SUPPRESS:
      return {
        ...state,
        suppressedByRules: true,
      };
    case WIDGET_UNSUPPRESS:
      return {
        ...state,
        suppressedByRules: false,
      };
    case WIDGET_UPDATE_STAGE:
      return {
        ...state,
        stage: action.record.stage,
      };
    case WIDGET_UPDATE_VISIBILITY:
      return {
        ...state,
        isVisible: action.record.isVisible,
      };
    case SET_INTERACTIVE_ONBOARDING:
      return {
        ...state,
        shouldShowInteractiveOnboarding: action.shouldShowInteractiveOnboarding,
      };
    default:
      return state;
  }
}

/*
 * Action creators
 */
export const initWidget = ({ orgDomain, loginDomain, appId, orgId }) => {
  return {
    type: WIDGET_INITIATE,
    record: {
      orgDomain,
      loginDomain,
      appId,
      orgId,
    },
  };
};

export function autoShowWidget() {
  return { type: WIDGET_AUTO_SHOW };
}

export const unminimizeWidget = () => ({
  type: WIDGET_UNMINIMIZE,
});

export const minimizeWidget = () => ({
  type: WIDGET_MINIMIZE,
});

export const hideWidget = () => {
  return {
    type: WIDGET_HIDE,
  };
};

export const suppress = () => {
  return {
    type: WIDGET_SUPPRESS,
  };
};

export const unsuppress = () => {
  return {
    type: WIDGET_UNSUPPRESS,
  };
};

export const updateCompositionDraft = text => {
  return {
    type: WIDGET_UPDATE_COMPOSITION_DRAFT,
    record: {
      text,
    },
  };
};

export const updateStage = stage => {
  return {
    type: WIDGET_UPDATE_STAGE,
    record: {
      stage,
    },
  };
};

export const updateVisibility = isVisible => {
  return {
    type: WIDGET_UPDATE_VISIBILITY,
    record: {
      isVisible,
    },
  };
};

export function setInteractiveOnboarding(shouldShowInteractiveOnboarding) {
  return { type: SET_INTERACTIVE_ONBOARDING, shouldShowInteractiveOnboarding };
}

/*
 * Thunk Actions
*/

export const showWidget = () => {
  return (dispatch, getState) => {
    const state = getState();
    if (!getIsSupressedByRules(state.ui)) {
      dispatch(updateVisibility(true));
    }
  };
};

export const showOnboarding = () => {
  return (dispatch, getState) => {
    const state = getState();
    dispatch(updateStage(STAGES.ONBOARDING));
    if (getIsAutoShow(state.ui)) {
      dispatch(showWidget());
    }
  };
};

export const beginChat = () => {
  return (dispatch, getState) => {
    dispatch(updateStage(STAGES.CHAT));
    dispatch(showWidget());
  };
};

export const showDemoSelfService = () => {
  return (dispatch, getState) => {
    const state = getState();
    dispatch(updateStage(STAGES.DEMO_SELF_SERVICE));
    if (getIsAutoShow(state.ui)) {
      dispatch(showWidget());
    }
  };
};

export const showSelfService = () => {
  return (dispatch, getState) => {
    const state = getState();
    dispatch(updateStage(STAGES.SELF_SERVICE));
    if (getIsAutoShow(state.ui)) {
      dispatch(showWidget());
    }
  };
};

export const startInteractiveOnboarding = () => {
  return (dispatch, getState) => {
    dispatch(setInteractiveOnboarding(true));
    dispatch(beginChat());
  };
};

export const endInteractiveOnboarding = () => {
  return (dispatch, getState) => {
    dispatch(setInteractiveOnboarding(false));
  };
};
